const REDIRECT_URL_SELECTOR = '[data-redirect-url]';

// Liquid can't ship JS, so pages that need a plain "redirect if this
// server-rendered condition is true" gate (e.g. signed-in customers on the
// login page) emit the target via a data attribute for this to pick up.
export const initConditionalRedirect = (): void => {
  const el = document.querySelector<HTMLElement>(REDIRECT_URL_SELECTOR);
  const url = el?.dataset.redirectUrl;
  if (url) window.location.href = url;
};
